// extracted by mini-css-extract-plugin
export default {"btn-close":"MobileCloseButton_btn-close__ujZT5"};